import LPSlidingHeader from "../LPSlidingHeader/LPSlidingHeader";
import LPContent from "./LPContent/LPContent";
import Footer from "../Footer/Footer";

function PageLogin() {
  return (
    <div>
      <LPContent />
      <Footer />
    </div>
  );
}

export default PageLogin;
